export default function DisLike({ ...props }) {
  return (
    <svg {...props} width="50" height="150" fill="none" viewBox="0 0 50 150">
      <path
        fill="#656364"
        d="M32.005 108.394C19 117.153-1.735 137.226-9.71 150V0c3.68 7.664 16.906 27.737 41.714 47.81 30.671 24.818 16.256 49.635 0 60.584z"
      ></path>
      <path
        fill="#fff"
        d="M29.224 67.367a1.208 1.208 0 00-1.71 0l-5.935 5.922-5.935-5.935a1.21 1.21 0 00-1.71 1.712L19.867 75l-5.935 5.934A1.212 1.212 0 0014.79 83a1.21 1.21 0 00.855-.354l5.935-5.935 5.934 5.935a1.208 1.208 0 002.066-.856 1.21 1.21 0 00-.355-.856L23.29 75l5.934-5.934a1.216 1.216 0 000-1.7z"
      ></path>
    </svg>
  );
}
